document.addEventListener("DOMContentLoaded", function () {

  const listing = document.querySelector('.blogListPosts');

  if (listing) {
    const btn = document.getElementById("loadmore-btn");
    let currentPage = 1;
    let activeFilters = {};

    // Handle filter changes using event delegation
    listing.addEventListener('click', function (e) {
      if (e.target.classList.contains('blogFilters__link')) {
        e.preventDefault();

        const filterValue = e.target.dataset.filter;
        const taxonomy = e.target.closest('.blogFilters__list').dataset.taxonomy;

        // Remove active class from all items
        document.querySelectorAll('.blogFilters__item').forEach(item => {
          item.classList.remove('blogFilters__item--active');
        });

        // Add active class to clicked item
        e.target.closest('.blogFilters__item').classList.add('blogFilters__item--active');

        // Update active filters
        if (filterValue && filterValue !== '') {
          activeFilters[taxonomy] = filterValue;
        } else {
          delete activeFilters[taxonomy];
        }

        // Reset to page 1 and filter posts
        currentPage = 1;
        filterPosts();
      }
    });

    // Load more functionality
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const postType = btn.dataset.type;
        showNextItems(btn, postType);
      });
    }

    function filterPosts() {
      const postType = btn ? btn.dataset.type : listing.dataset.postType;
      const event = btn ? btn.dataset.event : listing.dataset.event;
      const loadPostsContainer = document.querySelector('.blogListPosts__loadPostsHere');

      // Show loading state
      // loadPostsContainer.innerHTML = '<div class="loading-posts">Loading...</div>';

      let data = {
        'action': 'filter_' + postType,
        'page': 1,
        'security': loadmore_params.security,
        'post_type': postType,
        'event': event,
        'filters': JSON.stringify(activeFilters)
      };

      fetch(loadmore_params.ajaxurl, {
        method: 'POST',
        body: new URLSearchParams(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            loadPostsContainer.innerHTML = data.data.posts;

            // Update load more button
            if (btn) {
              if (data.data.max_pages > 1) {
                btn.style.display = 'block';
                btn.dataset.maxNumPages = data.data.max_pages;
                btn.classList.remove("loading");
              } else {
                btn.style.display = 'none';
              }
            }
          } else {
            loadPostsContainer.innerHTML = '<div class="no-posts">No posts found.</div>';
            if (btn) btn.style.display = 'none';
          }
        })
        .catch(error => {
          console.error('Filter error:', error);
          loadPostsContainer.innerHTML = '<div class="error-posts">Error loading posts.</div>';
        });
    }

    function showNextItems(button, postType) {
      button.classList.add("loading");

      let maxNumPages = button.dataset.maxNumPages;
      let event = button.dataset.event;
      currentPage++

      let data = {
        'action': 'loadmore_' + postType,
        'query': loadmore_params.posts,
        'page': currentPage,
        'security': loadmore_params.security,
        'max_num_pages': maxNumPages,
        'post_type': postType,
        'paged': currentPage,
        'event': event,
        'filters': JSON.stringify(activeFilters)
      };

      fetch(loadmore_params.ajaxurl, {
        method: 'POST',
        body: new URLSearchParams(data),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(response => response.text())
        .then(data => {
          if (data) {
            button.firstElementChild.textContent = 'Load more posts';
            loadmore_params.current_page++;

            let listingLoadPosts = document.querySelector('.blogListPosts__loadPostsHere');
            listingLoadPosts.insertAdjacentHTML('beforeend', data);

            if (loadmore_params.current_page == maxNumPages) {
              button.remove();
            } else {
              button.classList.remove("loading");
            }
          } else {
            button.remove();
          }
        })
        .catch(error => {
          button.firstElementChild.textContent = 'Load more posts';
          console.error(error);
        });
    }
  }

});
